<div nz-row class="meal-plan-card card-container-shadow">
  <div nz-col [nzXs]="24" [nzLg]="24">
    <div class="meal-plan-card-header d-flex tw-items-start justify-content-between">
      <p class="text-title-md text-upper-case"> {{ mealTime?.title }} </p>
      <div class="meal-plan-card-options d-flex">
        <div class="hour mr-xs" *ngIf="hour">
          <p class="text-info-bold tw-text-xs">{{ hour | date:'h:mm a' }}</p> <!-- 9:00 am -->
        </div>
        <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Modificar" class="icon-action tw-mr-2"
          (click)="onEmitEdit()" *ngIf="!mealTime.modeReadOnly">
          <i nz-icon nzType="edit" nzTheme="outline"></i>
        </div>
        <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger"
          (click)="onEmitRemove()" *ngIf="!mealTime.modeReadOnly">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </div>
        <div *ngIf="!mealTime.editMode" class="icon-action drag tw-ml-2">
          <span class="icon-drag tw-cursor-move" nz-icon nzType="drag" nzTheme="outline"></span>
        </div>
      </div>
    </div>
  </div>

  <div nz-col [nzXs]="24" [nzLg]="12">

    <div class="meal-plan-card-line mb-xs mt-xxs"></div>

    <ng-container *ngFor="let block of mealTime.blockPeriods">
      <div class="tw-flex tw-h-4 tw-mt-4">
        
        <ng-container *ngIf="block.type === blockPeriodTypeEnum.INDIVIDUAL && block.ingredients.length === 1; else generalIcon">
          <img  [src]="iconsRoute + iconsName[block.ingredients[0].category._id]" alt="" class="tw-h-4 tw-mr-1">
          <p class="text-info-bold mb-md">{{ block.title }}</p>
        </ng-container>

        <ng-template #generalIcon>
          <img [src]="periodTypesIconsMap[block.type]" alt="" class="tw-h-4 tw-mr-1">
          <p class="text-info-bold mb-md">{{ block.title }}</p>
        </ng-template>

      </div>

      <p class="text-info tw-ml-2" *ngIf="block.type === blockPeriodTypeEnum.INSTRUCTION">{{ block.text }}</p>



      <ul class="ingredient-list ml-xs" *ngIf="block?.ingredients?.length> 0">
        <li class="text-info d-flex align-items-center tw-ml-2" *ngFor="let ingredient of block?.ingredients">
          <span [class.tw-text-orange-500]="ingredient.isDislike && !ingredient.isAllergic"
            [class.tw-text-red-500]="ingredient.isAllergic">
            {{ ingredient.ingredientName }}. {{ ingredient.units }} {{ ingredient.units > 1 ?
            (ingredient.measure.namePlural_es ||
            ingredient.measure.namePlural) : (ingredient.measure.name_es || ingredient.measure.name) }}.
          </span>
        </li>
      </ul>
    </ng-container>


    <ng-container>
      <div class="line-divider mt-xs mb-md"></div>
      <div class="macronutrients d-flex justify-content-between mb-md">
        <div class="macronutrient">
          <p class="text-info-bold-xs mb-xxs opacity-70">Calorías</p>
          <p class="text-info text-bold">{{ mealTime.nutritionalProperties?.energy_kcal?.toFixed(2) || 0 }} kcal</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs mb-xxs opacity-70">Grasas</p>
          <p class="text-info text-bold">{{ mealTime.nutritionalProperties?.totalFat_g?.toFixed(2) || 0 }} g</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs mb-xxs opacity-70">Carbohidratos</p>
          <p class="text-info text-bold">{{ mealTime.nutritionalProperties?.carbohydrate_g?.toFixed(2) || 0 }} g</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs mb-xxs opacity-70">Proteínas</p>
          <p class="text-info text-bold">{{ mealTime.nutritionalProperties?.protein_g?.toFixed(2) || 0 }} g</p>
        </div>
        <div class="macronutrient">
          <p class="text-info-bold-xs mb-xxs opacity-70">Fibra</p>
          <p class="text-info text-bold">{{ mealTime.nutritionalProperties?.dietaryFiber_g?.toFixed(2) || 0 }} g</p>
        </div>
      </div>
    </ng-container>
  </div>

  <div nz-col [nzXs]="24" [nzLg]="12" class="tw-pl-8">
    <app-category-requirements [mealTime]="mealTime"></app-category-requirements>
  </div>



</div>